import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Tab,
  Tabs,
} from '@mui/material'
import { useState } from 'react'
import { copyButton, shareDialog, textfieldWrapper } from './RiskStoryShareDialog.styles'

interface RiskStoryEmbedScriptProps {
  embedDialogOpen: boolean
  storyLink: string
  handleCopy: (text: string, message: string) => () => Promise<void>
  onClose: (event: React.MouseEvent) => void
}

export const RiskStoryEmbedScript = ({
  embedDialogOpen,
  storyLink,
  handleCopy,
  onClose,
}: RiskStoryEmbedScriptProps) => {
  const [tabValue, setTabValue] = useState(0)
  const [width, setWidth] = useState('100%')
  const [height, setHeight] = useState('600px')

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }

  // Generate iframe code
  const iframeCode = `<iframe src="${storyLink}" width="${width}" height="${height}" frameborder="0" allowfullscreen></iframe>`

  // Generate script embed code
  const scriptEmbedCode = `<div id="rex-story-embed"></div>
<script>
  (function() {
    var iframe = document.createElement('iframe');
    iframe.src = '${storyLink}';
    iframe.width = '${width}';
    iframe.height = '${height}';
    iframe.frameBorder = '0';
    iframe.allowFullscreen = true;
    document.getElementById('rex-story-embed').appendChild(iframe);
  })();
</script>`

  const currentCode = tabValue === 0 ? iframeCode : scriptEmbedCode

  const handleCopyCode = handleCopy(currentCode, 'Text Copied')

  return (
    <Dialog css={shareDialog} open={embedDialogOpen} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Embed Risk Story</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Use this code to embed the Risk Story on your website. The story will be displayed in an
          iframe.
        </DialogContentText>

        <Box sx={{ mb: 2, mt: 4 }}>
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <TextField
              label="Width"
              value={width}
              onChange={(e) => setWidth(e.target.value)}
              size="small"
              sx={{ flex: 1 }}
              helperText="e.g., 100%, 800px"
            />
            <TextField
              label="Height"
              value={height}
              onChange={(e) => setHeight(e.target.value)}
              size="small"
              sx={{ flex: 1 }}
              helperText="e.g., 600px, 80vh"
            />
          </Box>
        </Box>

        <Tabs value={tabValue} onChange={handleTabChange} sx={{ mb: 2 }}>
          <Tab label="HTML iframe" />
          <Tab label="Script tag" />
        </Tabs>

        <Box css={textfieldWrapper}>
          <TextField
            style={{ width: '100%' }}
            multiline
            rows={tabValue === 0 ? 2 : 9}
            margin="dense"
            variant="outlined"
            value={currentCode}
            InputProps={{
              readOnly: true,
            }}
          />
          <Button variant="contained" size="small" css={copyButton} onClick={handleCopyCode}>
            Copy
          </Button>
        </Box>

        <DialogContentText sx={{ mt: 2, fontSize: '0.875rem' }}>
          Note: The embedded story will only be viewable if it is set to Public visibility.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          size="small"
          style={{ color: '#0074D3', margin: 10 }}
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
